import { render, staticRenderFns } from "./InsightsCreate.vue?vue&type=template&id=3aae6722&"
import script from "./InsightsCreate.vue?vue&type=script&lang=ts&"
export * from "./InsightsCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports